import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import Wrapper from '../../../layouts/Wrapper/Wrapper';
import Headers from '../../../core/Headers/Headers';
import { HeaderTabNavigation, LoadingSpinner } from 'components/core';

import { VendorProfileContainer } from './Profile/Profile';

import { useTitleCase } from 'hooks/useTitleCase';
import { handleVendorsInnerTabNavData } from 'constants/TabNavData';

import { isPermitted, useGetUserQuery } from '../../../../services/userApi';
import { useDeleteVendorMutation, useGetVendorsInfoQuery } from '../../../../services/vendorsApi';
import PaymentProfile from 'components/modules/Common/Payment/Payment';
import { NotificationForm } from './Notification/NotificationForm';

const VendorAccountContainer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vendorsInnerTabNavData] = handleVendorsInnerTabNavData(id);

  const { data, isSuccess, isError, isLoading } = useGetVendorsInfoQuery(id);

  const firstName = data?.individual?.first_name !== null ? data?.individual?.first_name : '';
  const lastName = data?.individual?.last_name !== null ? data?.individual?.last_name : '';
  const getbusinessName = data?.business_profile.name;
  const vendorName = getbusinessName ? getbusinessName : firstName + ' ' + lastName;

  const [mutation] = useDeleteVendorMutation();
  const { data: user } = useGetUserQuery({});

  async function deleteVendor() {
    // eslint-disable-next-line no-restricted-globals
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(
        `Are you sure you want to delete the vendor ${useTitleCase(
          vendorName
        )}, it cannot be undone?`
      )
    ) {
      const res: FetchBaseQueryError | SerializedError | any = await mutation(id);
      if (res.error && res.error.originalStatus !== 200) {
        alert('Error in deletion');
      }
      navigate('/vendors/active');
    }
  }

  return (
    <div>
      {/**
       * Handle loader
       */}
      {isLoading && <LoadingSpinner />}
      {/**
       * Error handling
       */}
      {isError && <Navigate to={'/401'} />}
      {isSuccess && (
        <Wrapper
          additionalClasses="flex-col items-end"
          pageTitle={useTitleCase(vendorName)}
          isBackButtonVisible
        >
          <Headers
            headingContent={useTitleCase(vendorName)}
            buttonLabel={'Delete Vendor'}
            onClick={deleteVendor}
            isButtonVisibled={isPermitted(user, 'delete-vendor')}
            isIconEnabled={true}
            variants={'extraSmallOutlined'}
            additionalClasses={'border-none'}
            iconType="TrashIcon"
            iconColor="inherit"
            headerWrapperClasses="border-none"
          />

          <HeaderTabNavigation tabNavData={vendorsInnerTabNavData} />

          <VendorProfileContainer data={data} user={user} />

          {/* {isPermitted(user, 'payment-tab') && ( */}
          <div className="flex flex-col w-full">
            <div className="flex flex-col w-full mb-0 pt-6 max-w-[1360px] border-t border-solid border-grey-100">
              <PaymentProfile isPaymentEditAccess={isPermitted(user, 'payment-tab')} />
            </div>
          </div>
          {/* )} */}

          <div className="flex flex-col w-full">
            <div className="flex flex-col w-full pt-6 mb-4 max-w-[1360px] border-t border-solid border-grey-100">
              <NotificationForm
                vendorData={data}
                vendorID={id}
                user={user}
                isPermitted={isPermitted}
              />
            </div>
          </div>
        </Wrapper>
      )}
    </div>
  );
};

export default VendorAccountContainer;
